
import { Component, Mixins } from "vue-property-decorator";
import { Size } from "../../../../../../base/domain/drawing";
import { ISizePropertyEditable, instanceOfISizePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class SizePropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ISizePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ISizePropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isSizeEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfISizePropertyEditable(s) && s.size().isEditable(), false);
  }

  get size(): Size {
    return this.readPropertyOrDefault(s => Size.from(s.size().getValue()), new Size(0, 0));
  }

  set size(value: Size) {
    this.writePropertyWhenValid(s => s.size().setValue(Size.to(value)));
  }
}
